// extracted by mini-css-extract-plugin
export var box = "_8l-1";
export var checkboxRow = "_8l-8";
export var checked = "_8l-2";
export var descriptionSpacer = "_8l-a";
export var disabled = "_8l-3";
export var icon = "_8l-6";
export var input = "_8l-0";
export var labelSpacer = "_8l-9";
export var medium = "_8l-5";
export var small = "_8l-4";
export var text = "_8l-7";